import { Controller } from "@hotwired/stimulus"

// Modal centrat pentru paginile de marketing (ERB), unde nu avem componenta
// React. Panoul este ascuns prin clasa `hidden` și se închide cu Escape, cu
// click pe overlay sau pe butonul de închidere.
//
// Panoul trebuie randat în afara oricărui element cu `transform` (cardul de
// preț are `hover:-translate-y-1`), pentru că un strămoș transformat devine
// bloc de referință pentru `position: fixed` — vezi shared/_pricing.
//
// Un `<iframe data-src="…">` din panou primește `src` abia la prima deschidere,
// ca un embed extern (Calendly) să nu se încarce la fiecare vizită. Un element
// `[data-modal-loading]` de lângă el dispare când iframe-ul s-a încărcat.
export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.boundHandleEscape = this.handleEscape.bind(this)
    document.addEventListener("keydown", this.boundHandleEscape)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundHandleEscape)
    document.body.style.overflow = ""
  }

  handleEscape(event) {
    if (event.key === "Escape" && this.isOpen) {
      this.close()
    }
  }

  open() {
    if (this.hasPanelTarget) {
      this.panelTarget.classList.remove("hidden")
      this.panelTarget.querySelectorAll("iframe[data-src]").forEach((frame) => {
        if (frame.getAttribute("src")) return

        const loading = frame.parentElement.querySelector("[data-modal-loading]")
        frame.addEventListener("load", () => loading?.remove(), { once: true })
        frame.setAttribute("src", frame.dataset.src)
      })
    }
    document.body.style.overflow = "hidden"
  }

  close() {
    if (this.hasPanelTarget) {
      this.panelTarget.classList.add("hidden")
    }
    document.body.style.overflow = ""
  }

  get isOpen() {
    return this.hasPanelTarget && !this.panelTarget.classList.contains("hidden")
  }
}
